import { __rest, __assign } from 'tslib';
import { jsx } from '@emotion/react/jsx-runtime';
import { SliderTrack as SliderTrack$1 } from '@reach/slider';
import { Box } from '../Box/index.js';

var SliderTrack = function (props) {
    var children = props.children; props.themeKey; var forwardProps = __rest(props, ["children", "themeKey"]);
    return (jsx(Box, __assign({ themeKey: "sliderTrack" }, { children: jsx(SliderTrack$1, __assign({}, forwardProps, { children: children })) })));
};
SliderTrack.displayName = "SliderTrack";

export { SliderTrack };
//# sourceMappingURL=SliderTrack.js.map
